import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import {
  portfolioJourneyQueryOptions,
  portfolioReviewOverviewQueryOptions,
  reviewBenchmarksQueryOptions,
} from "creso-core/hooks";
import { DEFAULT_REVIEW_BENCHMARK } from "@/modules/portfolio-review/constants";
import { PortfolioReviewLanding } from "@/modules/portfolio-review/components/portfolio-review-landing";

const ClientRoute = getRouteApi("/(auth)/_headed/clients/$id");

export const Route = createFileRoute("/(auth)/_headed/clients/$id/review")({
  component: RouteComponent,
  loader: ({ context, parentMatchPromise }) => {
    const { queryClient } = context;
    // Prefetch only; every section renders its own loading and error state.
    queryClient.prefetchQuery(reviewBenchmarksQueryOptions());
    parentMatchPromise.then(({ loaderData }) => {
      const guid = loaderData?.client.investment_account;
      if (!guid) return;
      queryClient.prefetchQuery(
        portfolioReviewOverviewQueryOptions({
          investment_account_guid: guid,
          source: "ALL",
        })
      );
      queryClient.prefetchQuery(
        portfolioJourneyQueryOptions({
          investment_account_guid: guid,
          source: "ALL",
          benchmark: DEFAULT_REVIEW_BENCHMARK,
          view: "returns",
        })
      );
    });
  },
});

function RouteComponent() {
  const { client } = ClientRoute.useLoaderData();
  return <PortfolioReviewLanding client={client} />;
}
